import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    coldList: {},
    coinList: [],
    feeList: {}
  },
  getters: {
    formatedList(state) {
      const result = [];

      for (let i in state.coldList) {
        const matched = result.find(item => item.coinType === i);
        if (!matched) {
          result.push({
            coinType: i,
            threshold: state.coldList[i]
          });
        } else {
          matched.threshold = state.coldList[i];
        }

        for (let j in state.feeList) {
          const matched = result.find(item => item.coinType === j);
          if (!matched) {
            result.push({
              coinType: j,
              fee: state.feeList[j]
            });
          } else {
            matched.fee = state.feeList[j];
          }
        }
      }
      return result;
    }
  },
  mutations: {
    setColdList(state, payload) {
      state.coldList = payload;
    },
    setFeeList(state, payload) {
      state.feeList = payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    getList({ commit }, coin) {
      api.getColdList(coin).then(({ data }) => {
        commit('setColdList', data);
      });
    },
    getFee({ commit }, coin) {
      api.getColdFee(coin).then(({ data }) => {
        commit('setFeeList', data);
      });
    },
    deteleCold(context, data) {
      return api.deteleCold(data);
    },
    addCold(context, data) {
      return api.addCold(data);
    },
    editFee(context, data) {
      return api.editFee(data);
    }
  }
};

appStore.registerModule('coldSetting', store);
